import { render, staticRenderFns } from "./accredView.vue?vue&type=template&id=8212f57e&scoped=true&"
import script from "./accredView.vue?vue&type=script&lang=js&"
export * from "./accredView.vue?vue&type=script&lang=js&"
import style0 from "./accredView.vue?vue&type=style&index=0&id=8212f57e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8212f57e",
  null
  
)

export default component.exports